const initialize = (sectionData) => {
  const formEl = document.querySelector(".gd-product .gd-product-form");

  const selectEl = formEl.querySelector("#gd-select-variant");
  if (selectEl) {
    selectEl.addEventListener("change", (e) => {
      const available = !selectEl.selectedOptions[0].disabled;
      const submitButton = formEl.querySelector(".gd-submit button[type=submit]");
      if (available) {
        submitButton.classList.remove("disabled");
        submitButton.disabled = false;
        submitButton.textContent = "カートに入れる";
      } else {
        submitButton.classList.add("disabled");
        submitButton.disabled = true;
        submitButton.textContent = "在庫なし";
      }
    });
  }
  const quantityControlEl = formEl.querySelector(".gd-quantity-control");
  const minusButton = quantityControlEl.querySelector(".gd-quantity-minus-button");
  minusButton.addEventListener("click", (e) => {
    const inputEl = formEl.querySelector("#gd-input-quantity");
    inputEl.value = Math.max(1, parseInt(inputEl.value) - 1);
  });
  const plusButton = quantityControlEl.querySelector(".gd-quantity-plus-button");
  plusButton.addEventListener("click", (e) => {
    const inputEl = formEl.querySelector("#gd-input-quantity");
    inputEl.value = parseInt(inputEl.value) + 1;
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (window.gd.template != "product" || !window.gd.sections) {
    return;
  }
  const sectionData = window.gd.sections.find((s) => s.type == "product");
  if (!sectionData) {
    return;
  }
  initialize(sectionData);
});
